export class TipoPartidaConstants {
  static NACIMIENTO = "Nacimiento"
  static DEFUNCION = "Defuncion"
}
